import backTriangleBlue from "@/assets/back-triangle-blue.svg";
import continueTriangleOrange from "@/assets/continue-triangle-orange.svg";
import { CONSTANT } from "@/util/ant_var";
import Button from "@/common/elements/Button";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import { INPUT_VARIANT } from "@/common/elements/InputElements/const";
import Select from "@/common/elements/InputElements/Select";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import FormActionsFooter from "../FormActionsFooter";
import AdministrativeInformation from "./AdministrativeInformation";
import BailInformation from "./BailInformation";
import ChargeInformation from "./ChargeInformation";
import ClearanceInformation from "./ClearanceInformation";
import CourtInformation from "./CourtInformation";
import DeadlineInformation from "./DeadlineInformation";
import OffenseInformation from "./OffenseInformation";
import OriginalChargeInformation from "./OriginalChargeInformation";
import SentencingInformation from "./SentencingInformation";
import {
  ActionsHeader,
  AddChargesContainer,
  ChargesSectionContainer,
} from "./styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import { Flex, Form, message } from "antd";
import { CaretLeftOutlined, CaretRightOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import useDialog from "@/hooks/useDialog";
import { isNonEmptyVariable } from "@/util/common_function";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import { useSelector } from "react-redux";

export const MODE = { NEW: "NEW", EDIT: "EDIT", VIEW: "VIEW" };

const formSteps = [
  { value: "charge-information", label: "Charge Information" },
  { value: "deadline-information", label: "Deadline Information" },
  { value: "offense-information", label: "Offense Information" },
  { value: "court-information", label: "Court Information" },
  {
    value: "additional-court-information",
    label: "Additional Court Information",
  },
  { value: "administrative-information", label: "Administrative Information" },
  {
    value: "original-charge-information",
    label: "Original Charge Information",
  },
  { value: "bail-information", label: "Bail Information" },
  { value: "sentencing-information", label: "Sentencing Information" },
  { value: "clearance-information", label: " Clearance Information" },
];

const AddCharges = forwardRef(
  ({
    formData,
    isEdit,
    chargeFormRef,
    bookingBails,
    isBooking = false,
    courtListsData,
    updateCourtListForm,
    chargesData,
    startingPoint
  }) => {
    const [form] = Form.useForm();
    const [loginUser, setLoginUser] = useState(null);
    const { showDialog } = useDialog();
    const [gtdls, setgtdls] = useState(0);
    const [controllingChargeValidation, setControllingChargeValidation] = useState(true);

    useImperativeHandle(chargeFormRef, () => ({
      form: form,
    }));

    const controllingCharge = Form.useWatch("controllingCharge", form);
    const requiresBond = Form.useWatch("requiresBond", form);
    const sentenced = Form.useWatch("sentenced", form);
    const clearedToGo = Form.useWatch("clearedToGo", form);
    const originalCustodyReasonID = Form.useWatch(
      "originalCustodyReasonID",
      form
    );
    const fullSearch = useSelector(state => state.fullSearch);
    const [holidays, setHolidays] = useState([])
    async function getAllHolidays() {
      try {
        let { data } = await api.get(API_ENDPOINTS.config.holidays.getAll)
        if (data?.length) {
          console.log({ holidayData: data })

          setHolidays(data)
        }

      } catch (error) {
        console.log(error)
      }

    }
    useEffect(() => {
      getAllHolidays()
    }, [])
    const chargeDescriptionID = Form.useWatch("chargeDescriptionID", form);
    const deadlineStartDateTime = Form.useWatch("deadlineStartDateTime", form);
    const offenderDispositionID = Form.useWatch("offenderDispositionID", form);
    const sentenceConsecutive = Form.useWatch("sentenceConsecutive", form);
    const releaseDateOverridden = Form.useWatch("releaseDateOverridden", form);
    const sentenceLength = Form.useWatch("sentenceLength", form);
    const stayedOrSuspendedDays = Form.useWatch("stayedOrSuspendedDays", form);
    const treatmentDays = Form.useWatch("treatmentDays", form);
    const creditDaysServed = Form.useWatch("creditDaysServed", form);
    const goodTimeDays = Form.useWatch("goodTimeDays", form);
    const goodTimeDaysLost = Form.useWatch("goodTimeDaysLost", form);
    const sentenceStartDateTime = Form.useWatch("sentenceStartDateTime", form);
    const originalChargeDescriptionID = Form.useWatch(
      "originalChargeDescriptionID",
      form
    );
    const totalDaysForThisCharge = Form.useWatch(
      "totalDaysForThisCharge",
      form
    );

    const { bookingsFieldsEnabled } = useSelector(
      (state) => state?.bookings
    );

    useEffect(() => {
      const user = JSON.parse(localStorage.getItem("userDetails"));
      setLoginUser(user);
      if (isEdit && isNonEmptyVariable(chargesData) && chargesData?.length) {
        const data = chargesData?.filter(
          (c) => c?.controllingCharge || c?.controllingCharge === "True"
        );
        if (data?.length > 1) {
          setControllingChargeValidation(() => false);
        } else {
          setControllingChargeValidation(() => true);
        }
      }

      setTimeout(() => {
        if (chargesData?.length === 0 && !fullSearch) {
          form.setFieldsValue({
            controllingCharge: true,
          });
        }
      }, 100);
    }, []);

    useEffect(() => {
      if (!isEdit) {
        form.setFieldsValue({
          sentenceDate: null,
          sentenceStartDateTime: null,
          sentenceEndDate: null,
          scheduledReleaseDateTime: null,
        });
      }
      if(!fullSearch) {
        setTimeout(() => {
          form.setFieldValue("chargeCount", 1);
        }, 100);
      }

      if (isNonEmptyVariable(formData)) {
        form.setFieldsValue(formData);
      }
    }, [formData]);

    useEffect(() => {
      if (isNonEmptyVariable(chargesData) && chargesData?.length) {
        const data = chargesData?.some(
          (c) => c?.controllingCharge || c?.controllingCharge === "True"
        );
        if (data) {
          setControllingChargeValidation(() => false);
        } else {
          setControllingChargeValidation(() => true);
        }
      } else {
        setControllingChargeValidation(() => true);
      }
    }, [controllingCharge]);

    useEffect(() => {
      if (isNonEmptyVariable(chargeDescriptionID)) {
        const url =
          API_ENDPOINTS.vwCharges_refListItemGlobalID +
          "/" +
          chargeDescriptionID;
        api.get(url).then((data1) => {
          const { data } = data1;

          if (data?.length) {
            // FE 51500001
            // GM 51500003
            // MS 51500006
            // PM 51500004

            if (data?.[0]?.chargeLevel === "FE") {
              form.setFieldValue("chargeLevelID", 51500001);
            } else if (data?.[0]?.chargeLevel === "GM") {
              form.setFieldValue("chargeLevelID", 51500003);
            } else if (data?.[0]?.chargeLevel === "MS") {
              form.setFieldValue("chargeLevelID", 51500006);
            } else if (data?.[0]?.chargeLevel === "PM") {
              form.setFieldValue("chargeLevelID", 51500004);
            } else {
            }

            const attribValue = data?.[0]?.refListItemAttribs?.find(
              (r) => r?.attribName === "UOC_Code"
            )?.attribValue;

            if (isNonEmptyVariable(attribValue)) {
              form.setFieldValue("ucrCode", attribValue);
            }
          }
        });
      } else {
        form.setFieldValue("chargeLevelID", "");
        form.setFieldValue("ucrCode", "");
      }
    }, [chargeDescriptionID]);

    useEffect(() => {
      if (isNonEmptyVariable(originalChargeDescriptionID)) {
        const url =
          API_ENDPOINTS.vwCharges_refListItemGlobalID +
          "/" +
          originalChargeDescriptionID;
        api.get(url).then((data1) => {
          const { data } = data1;

          if (data?.length) {
            // FE 51500001
            // GM 51500003
            // MS 51500006
            // PM 51500004

            if (data?.[0]?.chargeLevel === "FE") {
              form.setFieldValue("originalChargeLevelID", 51500001);
            } else if (data?.[0]?.chargeLevel === "GM") {
              form.setFieldValue("originalChargeLevelID", 51500003);
            } else if (data?.[0]?.chargeLevel === "MS") {
              form.setFieldValue("originalChargeLevelID", 51500006);
            } else if (data?.[0]?.chargeLevel === "PM") {
              form.setFieldValue("originalChargeLevelID", 51500004);
            } else {
            }

            const attribValue = data?.[0]?.refListItemAttribs?.find(
              (r) => r?.attribName === "UOC_Code"
            )?.attribValue;

            if (isNonEmptyVariable(attribValue)) {
              form.setFieldValue("originalUCRCode", attribValue);
            }
          }
        });
      } else {
        form.setFieldValue("originalChargeLevelID", "");
        form.setFieldValue("originalUCRCode", "");
      }
    }, [originalChargeDescriptionID]);

    useEffect(() => {
      if (isNonEmptyVariable(sentenced) && sentenced) {
        form?.scrollToField(["sentence"], {
          behavior: "smooth",
          block: "center",
        });
        form.focusField(["sentence"]);
      }
    }, [sentenced]);

    useEffect(() => {
      if (isNonEmptyVariable(requiresBond) && requiresBond) {
        form?.scrollToField(["chooseBailType"], {
          behavior: "smooth",
          block: "center",
        });
        form.focusField(["chooseBailType"]);
      }
    }, [requiresBond]);

    useEffect(() => {
      if (clearedToGo && !fullSearch) {
        form.setFieldValue("clearedBy", loginUser?.staffId);
        form.setFieldValue("clearanceDateTime", dayjs());
        form?.scrollToField(["clearedBy"], {
          behavior: "smooth",
          block: "center",
        });
        form.focusField(["clearedBy"]);
      } else {
        form.setFieldValue("clearedBy", null);
        form.setFieldValue("clearanceDateTime", null);
      }
    }, [clearedToGo]);

    useEffect(() => {
      if (
        originalCustodyReasonID === 54180001 ||
        originalCustodyReasonID === 54180002
      ) {
        console.log("formData", formData);

        form.setFieldValue(
          "deadlineStartDateTime",
          formData?.deadlineStartDateTime || null
        );

        form.setFieldValue("deadlineDateTime1", formData?.deadlineDateTime1);
        form.setFieldValue("deadlineDateTime2", formData?.deadlineDateTime2);

        form.setFieldValue("deadlineSatisfied1", formData?.deadlineSatisfied1);
        form.setFieldValue(
          "deadlineSatisfiedDateTime1",
          formData?.deadlineSatisfiedDateTime1
        );
        form.setFieldValue("deadlineSatisfied2", formData?.deadlineSatisfied2);
        form.setFieldValue(
          "deadlineSatisfiedDateTime2",
          formData?.deadlineSatisfiedDateTime2
        );
      } else {
        form.setFieldValue("deadlineStartDateTime", null);
        form.setFieldValue("deadlineSatisfied1", false);
        form.setFieldValue("deadlineSatisfiedDateTime1", null);
        form.setFieldValue("deadlineSatisfied2", false);
        form.setFieldValue("deadlineSatisfiedDateTime2", null);
        form.setFieldValue("deadlineDateTime1Local", null);
        form.setFieldValue("deadlineDateTime2Local", null);
      }
    }, [originalCustodyReasonID]);

    useEffect(() => {
      if (isNonEmptyVariable(offenderDispositionID)) {
        form.setFieldValue("dispositionDate", dayjs());
      } else {
        form.setFieldValue("dispositionDate", null);
      }
    }, [offenderDispositionID]);
    function generateApperenceDate(apperenceDate, Holidays) {
      let newAppDate = new Date(apperenceDate?.$d).toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric"
      });
      if (Holidays?.length) {
        var isHoliday = Holidays.find((e) => e.holidayDate == newAppDate)
        console.log({ isHoliday, newAppDate, Holidays })
        if (!isHoliday) {
          // return dayjs(apperenceDate).add(36, "hour")?.hour(0).minute(0)
          return apperenceDate
        }
        else {
          return generateApperenceDate(
            dayjs(apperenceDate).add(24, "hour")?.hour(0).minute(0), Holidays
          )
        }
      }
      else {
        return apperenceDate
      }

      // dayjs(deadlineStartDateTime).add(36, "hour")?.hour(0).minute(0)
    }
    useEffect(() => {
      if (isNonEmptyVariable(deadlineStartDateTime)) {
        console.log({ deadlineStartDateTime })
        const apperenceDate = isNonEmptyVariable(deadlineStartDateTime)
          ? generateApperenceDate(
            dayjs(deadlineStartDateTime).add(36, "hour")?.hour(0).minute(0), holidays
          )
          : "";
        const pcDate = isNonEmptyVariable(deadlineStartDateTime)
          ? dayjs(deadlineStartDateTime).add(48, "hour")
          : "";
        form.setFieldValue("deadlineDateTime1Local", apperenceDate);
        form.setFieldValue("deadlineDateTime2Local", pcDate);

        form.setFieldValue("deadlineSatisfied1", formData?.deadlineSatisfied1);
        form.setFieldValue(
          "deadlineSatisfiedDateTime1",
          formData?.deadlineSatisfiedDateTime1 || null
        );
        form.setFieldValue("deadlineSatisfied2", formData?.deadlineSatisfied2);
        form.setFieldValue(
          "deadlineSatisfiedDateTime2",
          formData?.deadlineSatisfiedDateTime2 || null
        );
      } else {
        form.setFieldValue("deadlineDateTime1Local", null);
        form.setFieldValue("deadlineDateTime2Local", null);
        form.setFieldValue("deadlineSatisfied1", false);
        form.setFieldValue("deadlineSatisfied2", false);
        form.setFieldValue("deadlineSatisfiedDateTime1", null);
        form.setFieldValue("deadlineSatisfiedDateTime2", null);
      }
    }, [deadlineStartDateTime, holidays]);

    useEffect(() => {
      if (isNonEmptyVariable(sentenceStartDateTime)) {
        const sl = isNonEmptyVariable(sentenceLength)
          ? parseInt(sentenceLength)
          : 0;
        form.setFieldValue(
          "sentenceEndDate",
          sentenceStartDateTime.add(sl > 5 ? sl - 1 : sl, "day")
        );
        form.setFieldValue(
          "scheduledReleaseDateTime",
          sentenceStartDateTime
            .add(sl > 5 ? sl - 1 : sl, "day")
            .hour(4)
            .minute(0)
        );
      }
    }, [sentenceStartDateTime]);

    useEffect(() => {
      if (
        parseInt(sentenceLength) <= 5 &&
        !isNonEmptyVariable(sentenceStartDateTime)
      ) {
        form.setFieldValue("goodTimeDays", 0);
        form.setFieldValue("totalDaysForThisCharge", 0);

        form.setFieldValue("scheduledReleaseDateTime", sentenceStartDateTime);
        form.setFieldValue("sentenceEndDate", sentenceStartDateTime);
      } else {
        const sl = isNonEmptyVariable(sentenceLength)
          ? parseInt(sentenceLength)
          : 0;
        const ssd = isNonEmptyVariable(stayedOrSuspendedDays)
          ? parseInt(stayedOrSuspendedDays)
          : 0;
        const td = isNonEmptyVariable(treatmentDays)
          ? parseInt(treatmentDays)
          : 0;
        const cd = isNonEmptyVariable(creditDaysServed)
          ? parseInt(creditDaysServed)
          : 0;

        let gtd = isNonEmptyVariable(goodTimeDays) ? parseInt(goodTimeDays) : 0;

        const gtdl = isNonEmptyVariable(goodTimeDaysLost)
          ? parseInt(goodTimeDaysLost)
          : 0;

        if (sl > 9) {
          const value = Math.floor((ssd + td) / 3);

          if (value >= 1 && (ssd + td) % 3 === 0) {
            gtd = Math.floor(sl / 3) - value;
          } else {
            gtd = Math.floor(sl / 3);
          }
        } else {
          gtd = 0;
        }

        const totalDays = sl - ssd - td - cd - gtd + gtdl;

        if (isNonEmptyVariable(sentenceStartDateTime)) {
          const sed = sentenceStartDateTime.add(sl > 5 ? sl - 1 : sl, "day");
          form.setFieldValue("sentenceEndDate", sed);
          // const d = sl - Math.floor(sl / 3);
          form.setFieldValue(
            "scheduledReleaseDateTime",
            sentenceStartDateTime.add(totalDays, "day").hour(4).minute(0)
          );
        }

        form.setFieldValue("goodTimeDays", gtd);
        form.setFieldValue("totalDaysForThisCharge", totalDays);
      }
    }, [
      sentenceLength,
      stayedOrSuspendedDays,
      treatmentDays,
      goodTimeDaysLost,
      creditDaysServed,
    ]);

    const changeClearReason = (e) => {
      if (isNonEmptyVariable(formData?.clearanceReasonID)) {
        if (formData?.clearanceReasonID !== e) {
          showDialog("Warning", {
            title: "Reminder",
            content:
              "You must also update the Release Reason in the Release Information section of the Arrest Report",
            confirmButtonText: "Ok",
          });
        }
      }
    };
    // console.log(form.getFieldsValue(),"charges form")
    return (
      <>
        <AddChargesContainer>
          <Form
            form={form}
            // initialValues={formData}
            scrollToFirstError={{
              behavior: "instant",
              block: "end",
              focus: true,
            }}
            onBlur={(e) => {
              if (e.target.id === "sentenceLength") {
                if (
                  parseInt(sentenceLength) <= 5 &&
                  !isNonEmptyVariable(sentenceStartDateTime)
                ) {
                  showDialog("info", {
                    title: "Warning",
                    content:
                      "Sentence start date is required when sentence length is 5 days or less",
                    confirmButtonText: "Ok",
                  });
                }
              }
            }}
          >
            <Flex gap="middle">
              <FormItem
                name="controllingCharge"
                valuePropName="checked"
                justify="space-between"
                rules={ !fullSearch ?
                  (controllingChargeValidation ? [
                    {
                      validator: (_, value) =>
                        value
                          ? Promise.resolve()
                          : Promise.reject(
                            new Error("Controlling Charge is required")
                          ),
                    },
                  ]
                  : null) : []
                }
              >
                <Checkbox
                  disabled={!bookingsFieldsEnabled}
                  className="ant-text-dark"
                  variant={INPUT_VARIANT.INTAKE_FORM}
                  labelStyle={{ whiteSpace: "nowrap" }}
                >
                  Controlling Charge?
                </Checkbox>
              </FormItem>
              <FormItem
                name="requiresBond"
                valuePropName="checked"
                justify="space-between"
              >
                <Checkbox
                  className="ant-text-dark"
                  variant={INPUT_VARIANT.INTAKE_FORM}
                  labelStyle={{ whiteSpace: "nowrap" }}
                  disabled={!bookingsFieldsEnabled}
                >
                  Requires Bail?
                </Checkbox>
              </FormItem>
              <FormItem
                name="sentenced"
                valuePropName="checked"
                justify="space-between"
              >
                <Checkbox
                  className="ant-text-dark"
                  variant={INPUT_VARIANT.INTAKE_FORM}
                  labelStyle={{ whiteSpace: "nowrap" }}
                  disabled={!bookingsFieldsEnabled}
                >
                  Sentenced?
                </Checkbox>
              </FormItem>
              <FormItem
                name="clearedToGo"
                valuePropName="checked"
                justify="space-between"
              >
                <Checkbox
                  className="ant-text-dark"
                  variant={INPUT_VARIANT.INTAKE_FORM}
                  labelStyle={{ whiteSpace: "nowrap" }}
                  disabled={!bookingsFieldsEnabled}
                >
                  Cleared To GO?
                </Checkbox>
              </FormItem>
              <FormItem
                name="sealed"
                valuePropName="checked"
                justify="space-between"
              >
                <Checkbox
                  className="ant-text-dark"
                  variant={INPUT_VARIANT.INTAKE_FORM}
                  labelStyle={{ whiteSpace: "nowrap" }}
                  disabled={!bookingsFieldsEnabled}
                >
                  Sealed?
                </Checkbox>
              </FormItem>
            </Flex>
            <ChargesSectionContainer>
              <ChargeInformation
                originalCustodyReasonID={originalCustodyReasonID}
                startingPoint={startingPoint}
              />
              {clearedToGo && (
                <ClearanceInformation changeClearReason={changeClearReason} />
              )}

              {[54180001, 54180002]?.findIndex(
                (k) => k === originalCustodyReasonID
              ) !== -1 && (
                  <DeadlineInformation
                    deadlineStartDateTime={deadlineStartDateTime}
                  />
                )}

              <OffenseInformation />
              <CourtInformation
                courtListsData={courtListsData}
                updateCourtListForm={updateCourtListForm}
              />
              {sentenced && (
                <SentencingInformation
                  sentenceConsecutive={sentenceConsecutive}
                  releaseDateOverridden={releaseDateOverridden}
                  sentenceLength={sentenceLength}
                />
              )}
              {requiresBond && (
                <BailInformation
                  form={form}
                  isEdit={isEdit}
                  bookingBails={bookingBails}
                  formData={formData}
                />
              )}
              <OriginalChargeInformation
                originalChargeDescriptionID={originalChargeDescriptionID}
              />

              {/*<AdministrativeInformation />*/}
            </ChargesSectionContainer>

            {isBooking && <FormActionsFooter />}
          </Form>
        </AddChargesContainer>
      </>
    );
  }
);

export default AddCharges;
